"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdvancedSearchDynamicFilters = void 0;
const mapAdvancedSearchOpToStringColumnFilter_1 = require("../utils/mapAdvancedSearchOpToStringColumnFilter");
const useAdvancedSearchTextFieldOperatorOptions_1 = require("./useAdvancedSearchTextFieldOperatorOptions");
function useAdvancedSearchDynamicFilters(dynamicColumnData) {
    var _a, _b, _c, _d, _e;
    if (dynamicColumnData) {
        const columnDefs = dynamicColumnData.columnDefs.filter((columnDef) => { var _a; return ((_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.showInFilters) && ['string', 'string-array', 'id', 'id-array'].includes(columnDef.type); });
        if (columnDefs.length > 0) {
            const textFieldOperatorOptions = (0, useAdvancedSearchTextFieldOperatorOptions_1.useAdvancedSearchTextFieldOperatorOptions)();
            const advancedSearchItems = [];
            for (const columnDef of columnDefs) {
                if ((_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.columnHandlerName) {
                    const dynamicColumnLabel = (_c = (_b = columnDef.metadata) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : '';
                    const dynamicColumnName = `_dynamic_${columnDef.name}`;
                    const { filterOptions } = (_e = (_d = dynamicColumnData.handlerMap.get(columnDef.metadata.columnHandlerName)) === null || _d === void 0 ? void 0 : _d.handler) !== null && _e !== void 0 ? _e : {};
                    if (columnDef.type === 'string' && !filterOptions) {
                        advancedSearchItems.push({
                            label: dynamicColumnLabel,
                            value: dynamicColumnName,
                            operatorOptions: textFieldOperatorOptions,
                            dynamicColumnHandlerName: columnDef.metadata.columnHandlerName,
                            onGetStorageFilter: (operator, value) => {
                                const dynamicColumnFilter = (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)(dynamicColumnName, operator, value);
                                if (operator.startsWith('not')) {
                                    return {
                                        op: 'or',
                                        filter: [{ column: dynamicColumnName, op: 'is-null' }, dynamicColumnFilter],
                                    };
                                }
                                return dynamicColumnFilter;
                            },
                        });
                    }
                    else if (filterOptions) {
                        advancedSearchItems.push({
                            label: dynamicColumnLabel,
                            value: dynamicColumnName,
                            operatorOptions: textFieldOperatorOptions,
                            dynamicColumnHandlerName: columnDef.metadata.columnHandlerName,
                            onGetStorageFilter: (operator, value) => {
                                let arrayOperation;
                                if (columnDef.type.endsWith('array')) {
                                    if (operator.startsWith('not')) {
                                        arrayOperation = 'contained';
                                    }
                                    else {
                                        arrayOperation = 'overlap';
                                    }
                                }
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                const dynamicColumnFilter = {
                                    column: dynamicColumnName,
                                    op: arrayOperation !== null && arrayOperation !== void 0 ? arrayOperation : 'in',
                                    subFilter: {
                                        entity: filterOptions.subFilterEntity,
                                        column: filterOptions.subFilterColumn,
                                        filter: [filterOptions.onGetStorageSubFilter(operator, value)],
                                    },
                                };
                                if (operator.startsWith('not')) {
                                    if (columnDef.type.endsWith('array')) {
                                        return {
                                            op: 'or',
                                            filter: [{ column: dynamicColumnName, op: '=', value: [] }, dynamicColumnFilter],
                                        };
                                    }
                                    else {
                                        return {
                                            op: 'or',
                                            filter: [{ column: dynamicColumnName, op: 'is-null' }, dynamicColumnFilter],
                                        };
                                    }
                                }
                                return dynamicColumnFilter;
                            },
                        });
                    }
                    else {
                        console.warn(`DynamicColumnHandler.filterOptions is missing, DynamicColumnHandler=${columnDef.metadata.columnHandlerName}`);
                    }
                }
            }
            return advancedSearchItems;
        }
    }
    return undefined;
}
exports.useAdvancedSearchDynamicFilters = useAdvancedSearchDynamicFilters;
